import { render, staticRenderFns } from "./NavWave.vue?vue&type=template&id=2a2f9abc&scoped=true&"
import script from "./NavWave.vue?vue&type=script&lang=ts&"
export * from "./NavWave.vue?vue&type=script&lang=ts&"
import style0 from "./NavWave.vue?vue&type=style&index=0&id=2a2f9abc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f9abc",
  null
  
)

export default component.exports